import { Component, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorService } from '@kv-common-components/kv-common-components';
import { CodeMobileService } from '@kv-common-components/kx-services';
import { StyleService } from '@shared/services/style.service';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-bascule-mobile',
    templateUrl: 'bascule-mobile.component.html',
})
export class BasculeMobileComponent implements OnDestroy {
    @ViewChild('myForm', { static: false }) myForm: NgForm;
    activeRoute: string;
    primaryProvider: string;
    secondaryProvider: string;
    tokenBasculeMobile: string;
    firstCode: number;
    secondeCode: number;
    thirdCode: number;
    fourthCode: number;
    fifthCode: number;
    sixCode: number;
    codeMobile: string;
    firstTimeSubmitted = true;

    constructor(
        private activatedRoute: ActivatedRoute,
        private errorService: ErrorService,
        private codeMobileService: CodeMobileService,
        private router: Router,
        private logger: NGXLogger,
        private styleService: StyleService
    ) {
        this.primaryProvider =
            this.activatedRoute.snapshot.paramMap.get('primaryProvider');
        this.secondaryProvider =
            this.activatedRoute.snapshot.paramMap.get('secondaryProvider');
        this.tokenBasculeMobile =
            this.activatedRoute.snapshot.paramMap.get('tokenBasculeMobile');
        this.styleService.updatePageStyle('add', 'otp-page');
    }

    @HostListener('keyup', ['$event']) onKeyDown(e: any) {
        if (e.srcElement.maxLength === e.srcElement.value.length) {
            e.preventDefault();
            let nextControl: any = e.srcElement.nextElementSibling;
            while (true) {
                if (nextControl) {
                    if (nextControl.type === e.srcElement.type) {
                        nextControl.focus();
                        return;
                    } else {
                        nextControl = nextControl.nextElementSibling;
                    }
                } else {
                    return;
                }
            }
        }
    }
    checkPassword() {
        if (this.allCodesAreNotNull() && this.firstTimeSubmitted) {
            this.firstTimeSubmitted = false;
            this.codeMobile = `${this.firstCode}${this.secondeCode}${this.thirdCode}${this.fourthCode}${this.fifthCode}${this.sixCode}`;
            this.codeMobileService
                .validateCodeMobile(
                    this.codeMobile,
                    this.tokenBasculeMobile,
                    this.primaryProvider,
                    this.secondaryProvider
                )
                .subscribe(
                    (data: any) => {
                        this.logger.info('code mobile valide : ', { data });
                        localStorage.setItem(
                            'selectedDocumentType',
                            data.contexteUrl
                        );
                        this.router.navigateByUrl(
                            '/souscription/document-medicale/document-selection-type'
                        );
                    },
                    (error) => {
                        this.firstTimeSubmitted = true;
                        (
                            document.getElementById(
                                'codeForm'
                            ) as HTMLFormElement
                        ).reset();
                        this.errorService.setError(error);
                    }
                );
        }
    }

    ngOnDestroy(): void {
        this.styleService.updatePageStyle('remove', 'otp-page');
    }

    numberOnly(event): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    }

    private allCodesAreNotNull(): boolean {
        return (
            this.numberIsNotNull(this.firstCode) &&
            this.numberIsNotNull(this.secondeCode) &&
            this.numberIsNotNull(this.thirdCode) &&
            this.numberIsNotNull(this.fourthCode) &&
            this.numberIsNotNull(this.fifthCode) &&
            this.numberIsNotNull(this.sixCode)
        );
    }
    private numberIsNotNull(numberToCheck: number) {
        return numberToCheck !== undefined && numberToCheck !== null;
    }
}
